import * as tslib_1 from "tslib";
import { push, replace } from 'connected-react-router';
import { mapValues } from 'lodash';
import { stringify } from 'qs';
import { querySelector } from './selectors';

function normalizeValue(val) {
  if (val === null || val === '') {
    return undefined;
  }

  return val;
}

export function setQueryParams(newParams, _a) {
  var _b = (_a === void 0 ? {} : _a).saveToHistory,
      saveToHistory = _b === void 0 ? false : _b;
  return function (dispatch, getState) {
    var currentQuery = querySelector(getState());

    var newQuery = tslib_1.__assign({}, currentQuery, mapValues(newParams, normalizeValue));

    var searchString = stringify(newQuery, {
      addQueryPrefix: true
    });
    var pushOrReplace = replace;

    if (saveToHistory) {
      pushOrReplace = push;
    }

    return dispatch(pushOrReplace({
      search: searchString
    }));
  };
}
export { push as pushLocation };